import {
    FormControl,
    Grid,
    InputLabel,
    Select,
    TextField,
    MenuItem,
} from "@mui/material";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import * as yup from "yup";
import { useEffect } from "react";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import {
    adderCategoriesReset,
    CreateCategoryChildrenMethod
} from "../../Redux/AddersCategoriesSlice/AddersCategoriesSlice";
import {
    adderReset,
    DeleteAddreMethod,
    GetAllAdders,
    GetAddersChildrens
} from "../../Redux/AddersSlicev2/AddersSlicev2";

const CreateGroupChildren = ({group_id}) => {
    
    const dispatch = useDispatch();
    // const { isLoading, isError, errors } = useSelector(
    //     (state) => state.adders_categories
    // );
    
    const { adders, adder_childrens,isSuccess,isLoading, isError, errors } = useSelector(
        (state) => state.addersv2
    );
    const AllAddersVal = adders?.data || [];
    const AllChildrenVal = adder_childrens?.data || [];

    console.log("AllChildrenVal",AllChildrenVal)
    const formik = useFormik({
        initialValues: {
            group_parent_id: group_id,
            adder: 0,
            members: 0,
            submit: false,
        },
        onSubmit: async (values) => {
            values.submit = true;
            let formdata = new FormData()
            formdata.append("group_parent_id", values?.group_parent_id);
            formdata.append("members[0]", values?.members);

            console.log(values)
            console.log("formdata",formdata)
            await dispatch(CreateCategoryChildrenMethod(formdata));
            await dispatch(adderCategoriesReset());
        },
    });

    const GetAllAddersAction = async () => {
        await dispatch(
            GetAllAdders({
                return_all: 1,
            })
        );
    };
    useEffect(() => {
        GetAllAddersAction();
    }, []);

    useEffect(() => {
        if (isError) {
            if (errors) {
                Object.keys(errors).forEach((key) => {
                    let error = errors[key][0];
                    toast.error(error);
                });
            }
            const reset = async () => {
                await dispatch(adderCategoriesReset());
            };
            reset();
        }
    }, [dispatch, errors, isError]);

    useEffect(() => {
        if (isSuccess && formik.values.submit) {
            toast.success("Created successfully");
            formik.values.adder = "";
            formik.values.members = "";
        }
    }, [formik.values, isSuccess]);

    const GetAllAddersChildrensAction = async (parent_id) => {
        await dispatch(
            GetAddersChildrens({
                return_all: 1,
                parent_id: parent_id || 0
            })
        );
    };

    
    const handelChangeAdderValue = ({target}) => {
        let value = target?.value
        GetAllAddersChildrensAction(value);
    }

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <FormContainer>
                    <FormHeading> Add Children </FormHeading>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                        Adders
                                    </InputLabel>
                                    <Select
                                        id="adder"
                                        name="adder"
                                        label="Adders"
                                        value={formik.values.adder}
                                        onChange={(e) => handelChangeAdderValue(e)}
                                    >
                                        {AllAddersVal?.map((key, index) => (
                                            <MenuItem
                                                key={index}
                                                value={key.id}
                                            >
                                                {key.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                        Childrens
                                    </InputLabel>
                                    <Select
                                        id="members"
                                        name="members"
                                        label="Childrens"
                                        value={formik.values.members}
                                        onChange={formik.handleChange}
                                    >
                                        {AllChildrenVal?.map((key, index) => (
                                            <MenuItem
                                                key={index}
                                                value={key.id}
                                            >
                                                {key.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <PrimaryButton fullWidth type="submit">
                            {isLoading ? "loading ... " : " Add Children"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;
export default CreateGroupChildren;
